import React, { useEffect, useState } from 'react';

const Footer = () => {
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScroll && window.pageYOffset > 500) {
        setShowScroll(true);
      } else if (showScroll && window.pageYOffset <= 500) {
        setShowScroll(false);
      }
    };
    window.addEventListener('scroll', checkScrollTop);
    return () => window.removeEventListener('scroll', checkScrollTop);
  }, [showScroll]);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <footer>
        <div className="footer-content">
          <div className="footer-brand-center">
            <img src="/images/Zentak.png" alt="Zentak Logo" style={{ width: '160px', height: 'auto', marginBottom: '1.1rem' }} />
            <p style={{ textAlign: 'center', maxWidth: '420px', color: 'rgba(255,255,255,0.7)', margin: '0 auto' }}>
              Innovative glassmorphic software solutions that drive business growth and digital transformation.
            </p>
          </div>
          <div className="footer-links-row">
            <div className="footer-section">
              <h3>Company</h3>
              <ul className="footer-links">
                <li><a href="#features">About Us</a></li>
                <li><a href="#contact">Contact</a></li>
              </ul>
            </div>
            <div className="footer-section">
              <h3>Services</h3>
              <ul className="footer-links">
                <li><a href="#services">Web Development</a></li>
                <li><a href="#services">Mobile Apps</a></li>
                <li><a href="#services">UI/UX Design</a></li>
              </ul>
            </div>
            <div className="footer-section">
              <h3>Social</h3>
              <ul className="footer-links">
                <li>
                  <a href="https://www.facebook.com/ZentakSolutions" target="_blank" rel="noopener noreferrer" aria-label="Facebook" style={{ display: 'flex', alignItems: 'center', gap: '0.5em' }}>
                    {/* Facebook SVG icon */}
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: 'middle' }}>
                      <path d="M22.675 0h-21.35C.595 0 0 .592 0 1.326v21.348C0 23.408.595 24 1.325 24h11.495v-9.294H9.692v-3.622h3.128V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.797.143v3.24l-1.918.001c-1.504 0-1.797.715-1.797 1.763v2.313h3.587l-.467 3.622h-3.12V24h6.116C23.406 24 24 23.408 24 22.674V1.326C24 .592 23.406 0 22.675 0"/>
                    </svg>
                    Facebook
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 Zentak Solutions. All rights reserved.</p>
        </div>
      </footer>
      {/* Scroll to Top Button */}
      <div 
        className={`scroll-top ${showScroll ? 'show' : ''}`} 
        onClick={scrollTop}
      >
        ↑
      </div>
    </>
  );
}

export default Footer;